// extracted by mini-css-extract-plugin
export default {"container":"XamIuZy99Y6uqoKsIDFH","modalBody":"JzEt54b40KEGkUo3Fccg","tabContent":"V2IEYLAjwTQTfheuhIFr"};